import { isEqual } from "es-toolkit/compat";
import { useEffect } from "react";
import type {
  Control,
  DefaultValues,
  FieldValues,
  FormState,
  SubmitHandler,
  UseFormProps,
  UseFormReturn,
} from "react-hook-form";
import {
  Path,
  useForm as useHookForm,
  useFormState as useHookFormState,
  useWatch as useHookWatch,
} from "react-hook-form";
import { usePrevious } from "./usePrevious";

export const useForm = <T extends FieldValues>(
  props?: Exclude<UseFormProps<T>, "defaultValues"> & {
    defaultValues?: DefaultValues<T>;
  }
): UseFormReturn<T> => {
  const methods = useHookForm({ mode: "onChange", ...props });

  // if defaultValues is updated, reset the form with those values
  const previousDefaultValues = usePrevious(props?.defaultValues);

  useEffect(() => {
    if (
      props?.defaultValues &&
      !isEqual(previousDefaultValues, props?.defaultValues)
    ) {
      methods.reset(props?.defaultValues);
    }
  }, [props?.defaultValues]);

  return methods;
};

export {
  useHookForm,
  useHookFormState,
  useHookWatch,
  type Control,
  type DefaultValues,
  type FieldValues,
  type FormState,
  type Path,
  type SubmitHandler,
  type UseFormProps,
  type UseFormReturn,
};

export default useForm;
